import React from "react";

import {Button, Table, TableBody, TableCell, TableHead, TableRow} from '@aws-amplify/ui-react';
import LinearProgressWithLabel  from '@mui/material/LinearProgress';
import {Storage} from "aws-amplify";
import {FaRegFile} from 'react-icons/fa'


function ReferenceProcessing(props) {
    const [signedUrlExtractES, setSignedUrlExtractES] = React.useState(null)
    const [signedUrlDecode, setSignedUrlDecode] = React.useState(null)
    const [signedUrlExtractFeat, setSignedUrlExtractFeat] = React.useState(null)
    const [signedUrlCreateHLS, setSignedUrlCreateHLS] = React.useState(null)

    React.useEffect(()=> {
        async function getAWSUrl() {
            if (props.RefProc.progress_extract_es === 100) {
                const fileAccessURLReference = await Storage.get(
                    props.RefProc.id + "/media.es.txt",
                    {
                        level: 'protected',
                        identityId: props.RefProc.user_identity_id,
                        expires: 86400 });
                setSignedUrlExtractES(fileAccessURLReference);
            }
        }
        getAWSUrl()
    }, [props.RefProc.id, props.RefProc.progress_extract_es, props.RefProc.user_identity_id])

    React.useEffect(()=> {
        async function getAWSUrl() {
            if (props.RefProc.progress_decode === 100) {
                const fileAccessURLReference = await Storage.get(
                    props.RefProc.id + "/media.decode.txt",
                    {
                        level: 'protected',
                        identityId: props.RefProc.user_identity_id,
                        expires: 86400 });
                setSignedUrlDecode(fileAccessURLReference);
            }
        }
        getAWSUrl()
    }, [props.RefProc.id, props.RefProc.progress_decode, props.RefProc.user_identity_id])

    React.useEffect(()=> {
        async function getAWSUrl() {
            if (props.RefProc.progress_extract_feat === 100) {
                const fileAccessURLReference = await Storage.get(
                    props.RefProc.id + "/reference.extract_feature.txt",
                    {
                        level: 'protected',
                        identityId: props.RefProc.user_identity_id,
                        expires: 86400 });
                setSignedUrlExtractFeat(fileAccessURLReference);
            }
        }
        getAWSUrl()
    }, [props.RefProc.id, props.RefProc.progress_extract_feat, props.RefProc.user_identity_id])

    React.useEffect(()=> {
        async function getAWSUrl() {
            if (props.RefProc.progress_create_hls === 100) {
                const fileAccessURLReference = await Storage.get(
                    props.RefProc.id + "/media.hls.txt",
                    {
                        level: 'protected',
                        identityId: props.RefProc.user_identity_id,
                        expires: 86400 });
                setSignedUrlCreateHLS(fileAccessURLReference);
            }
        }
        getAWSUrl()
    }, [props.RefProc.id, props.RefProc.progress_create_hls, props.RefProc.user_identity_id])

    return (
        <>
            <Table>
                <TableHead>
                <TableRow>
                    <TableCell as={"th"} className="synamedia-th">Process</TableCell>
                    <TableCell as={"th"} className="synamedia-th">Progress</TableCell>
                    <TableCell as={"th"}/>
                    <TableCell as={"th"} className="synamedia-th text-right">Log</TableCell>
                </TableRow>
                </TableHead>
                <TableBody>
                {props.RefProc.progress_cross_copy ?
                    <TableRow>
                        <TableCell className="synamedia-td">Cross Account S3 copy</TableCell>
                        <TableCell className="synamedia-td"> {props.RefProc.progress_cross_copy === 100 ? "Completed" :
                            <LinearProgressWithLabel
                                max="100"
                                value={props.RefProc.progress_cross_copy ? props.RefProc.progress_cross_copy : 0}
                                />
                        }
                        </TableCell>
                        <TableCell className="synamedia-td">{props.RefProc.progress_cross_copy ? props.RefProc.progress_cross_copy + "%": ""}</TableCell>
                        <TableCell/>
                    </TableRow> : <></> }
                {props.RefProc.progress_extract_es ?
                <TableRow>
                    <TableCell className="synamedia-td">Extract Elementary stream</TableCell>
                    <TableCell className="synamedia-td"> {props.RefProc.progress_extract_es === 100 ? "Completed" :
                        <LinearProgressWithLabel
                            value={props.RefProc.progress_extract_es ? props.RefProc.progress_extract_es : 0}
                            />
                    }
                    </TableCell>
                    <TableCell className="synamedia-td">{props.RefProc.progress_extract_es ? props.RefProc.progress_extract_es + "%": ""}</TableCell>
                    <TableCell className="td-actions text-right">
                        {
                            (props.RefProc.progress_extract_es === 100) ?
                                <a href={signedUrlExtractES} target="_blank" rel="noopener noreferrer">
                                    <Button
                                        className="yellow-chart-button"
                                        size="small"
                                        type="button"
                                    >
                                        <FaRegFile/>
                                    </Button>
                                </a>
                                :
                                ""
                        }
                    </TableCell>
                </TableRow> : <></> }
                {props.RefProc.progress_decode ?
                <TableRow>
                    <TableCell className="synamedia-td">Decode</TableCell>
                    <TableCell className="synamedia-td"> {props.RefProc.progress_decode === 100 ? "Completed" :
                        <LinearProgressWithLabel
                            value={props.RefProc.progress_decode ? props.RefProc.progress_decode : 0}
                            />
                    }
                    </TableCell>
                    <TableCell className="synamedia-td">{props.RefProc.progress_decode ? props.RefProc.progress_decode + "%": ""}</TableCell>
                    <TableCell className="td-actions text-right">
                        {
                            (props.RefProc.progress_decode === 100) ?
                                <a href={signedUrlDecode} target="_blank" rel="noopener noreferrer">
                                    <Button
                                        className="yellow-chart-button"
                                        size="small"
                                        type="button"
                                    >
                                        <FaRegFile/>
                                    </Button>
                                </a>
                                :
                                ""
                        }
                    </TableCell>
                </TableRow> : <></> }
                {props.RefProc.progress_extract_feat ?
                <TableRow>
                    <TableCell className="synamedia-td">Extract features</TableCell>
                    <TableCell className="synamedia-td">{props.RefProc.progress_extract_feat === 100 ? "Completed" :
                        <LinearProgressWithLabel
                            value={props.RefProc.progress_extract_feat ? props.RefProc.progress_extract_feat : 0}
                            />
                    }
                    </TableCell>
                    <TableCell className="synamedia-td">{props.RefProc.progress_extract_feat ? props.RefProc.progress_extract_feat + "%": ""}</TableCell>
                    <TableCell className="td-actions text-right">
                        {
                            (props.RefProc.progress_extract_feat === 100) ?
                                <a href={signedUrlExtractFeat} target="_blank" rel="noopener noreferrer">
                                    <Button
                                        className="yellow-chart-button"
                                        size="small"
                                        type="button"
                                    >
                                        <FaRegFile/>
                                    </Button>
                                </a>
                                :
                                ""
                        }
                    </TableCell>
                </TableRow> : <></> }
                {props.RefProc.progress_create_hls ?
                <TableRow>
                    <TableCell className="synamedia-td">Create HLS stream</TableCell>
                    <TableCell className="synamedia-td">{props.RefProc.progress_create_hls === 100 ? "Completed" :
                        <LinearProgressWithLabel
                            value={props.RefProc.progress_create_hls ? props.RefProc.progress_create_hls : 0}
                            />
                    }
                    </TableCell>
                    <TableCell className="synamedia-td">{props.RefProc.progress_create_hls ? props.RefProc.progress_create_hls + "%": ""}</TableCell>
                    <TableCell className="td-actions text-right">
                        {
                            (props.RefProc.progress_create_hls === 100) ?
                                <a href={signedUrlCreateHLS} target="_blank" rel="noopener noreferrer">
                                    <Button
                                        className="yellow-chart-button"
                                        size="small"
                                        type="button"
                                    >
                                        <FaRegFile/>
                                    </Button>
                                </a>
                                :
                                ""
                        }
                    </TableCell>
                </TableRow> : <></> }
                </TableBody>
            </Table>
        </>
    );
}

export default ReferenceProcessing;
